import styled from 'styled-components';

const PlanWarning = styled.div<{red?: boolean}>`
  margin-top: 8px;
  font-weight: 500;
  ${props => props.red && 'color: #bd3115;'};
`;

export default PlanWarning;
